var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.33073C0 1.41025 0.746192 0.664062 1.66667 0.664062H28.3333C29.2538 0.664062 30 1.41025 30 2.33073C30 3.2512 29.2538 3.9974 28.3333 3.9974H1.66667C0.746193 3.9974 0 3.2512 0 2.33073Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.6641C0 9.74359 0.746192 8.9974 1.66667 8.9974H28.3333C29.2538 8.9974 30 9.74359 30 10.6641C30 11.5845 29.2538 12.3307 28.3333 12.3307H1.66667C0.746193 12.3307 0 11.5845 0 10.6641Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.9974C10 18.0769 10.7462 17.3307 11.6667 17.3307H28.3333C29.2538 17.3307 30 18.0769 30 18.9974C30 19.9179 29.2538 20.6641 28.3333 20.6641H11.6667C10.7462 20.6641 10 19.9179 10 18.9974Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.fed4f787434351e5420e135e9403431c.svg";
export { ForwardRef as ReactComponent };